import { render, staticRenderFns } from "./organizationalStructure.vue?vue&type=template&id=5999caa8&scoped=true"
import script from "./organizationalStructure.vue?vue&type=script&lang=js"
export * from "./organizationalStructure.vue?vue&type=script&lang=js"
import style0 from "./organizationalStructure.vue?vue&type=style&index=0&id=5999caa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5999caa8",
  null
  
)

export default component.exports